import { ArrowUpRightIcon, PlayIcon } from 'lucide-react';
import { HeadingText } from '../shared/HeadingText';
import { usePages } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';
import { fill } from '../../utils/copy';
import { sectionHeading } from '../../ui/sections';
import { btnOnClay, iconCircleOnClay } from '../../ui/styles';

/**
 * Podcastblok onder het journal, op klei: intro, onderwerpen en de afleveringen (extern).
 * Op klei alleen vol `text-shell` (5,6:1); blush alleen voor het grote accent in de kop.
 */
export function JournalPodcast() {
  const pages = usePages();
  const copy = pages.journal;
  const podcastUrl = copy.podcast.url;
  return <section className="bg-clay py-20 text-shell sm:py-24 lg:py-32" aria-labelledby="podcast-title" data-id="element-7654" data-mp="133m3b6g178c8">
      <div className="mx-auto grid max-w-content gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-7655" data-mp="29jodtqla6v5a">
        <div className="lg:col-span-5" data-id="element-7656" data-mp="2eir7yfzq3gyh">
          {copy.podcast.eyebrow && <p className="text-[14px] text-shell" data-id="element-7657" data-mp="2egy1b0p40wqh">{fill(copy.podcast.eyebrow)}</p>}
          <h2 id="podcast-title" className={`mt-5 ${sectionHeading}`} data-id="element-7658" data-mp="6wtm90hea73b">
            <HeadingText heading={copy.podcast.heading} accentClassName="text-blush" data-id="element-7659" data-mp="1yi7cbc8t6e8" />
          </h2>
          {copy.podcast.body && <p className="mt-7 max-w-md text-[17px] leading-relaxed text-shell" data-id="element-7660" data-mp="3u1hrv026izik">{fill(copy.podcast.body)}</p>}
          <ul className="mt-7 flex flex-wrap gap-2" aria-label="Onderwerpen" data-id="element-7661" data-mp="3p37x2qkda0xh">
            {copy.podcast.topics.map(t => <li key={t} className="rounded-full border border-shell/40 px-3 py-1 text-[13px] text-shell" data-id="element-7662" data-mp="3k6prxpl4k0km">
                {t}
              </li>)}
          </ul>
          {copy.podcast.cta && <a href={podcastUrl} target="_blank" rel="noreferrer" className={`mt-9 ${btnOnClay}`} data-id="element-7663" data-mp="36d8bwernd5zc">
              {fill(copy.podcast.cta)}
              <span className="sr-only" data-id="element-7664" data-mp="2wf2eoagsco0t"> {shopLabels.newTab}</span>
              <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7665" data-mp="2wfu576vizvk8" />
            </a>}
        </div>
        <ul className="divide-y divide-shell/25 border-y border-shell/25 lg:col-span-7" aria-label="Afleveringen" data-id="element-7666" data-mp="2rqjb89lnsmrd">
          {copy.episodes.map(e => <li key={e.number} data-id="element-7667" data-mp="2cutq0doasdnp">
              <a href={podcastUrl} target="_blank" rel="noreferrer" className="group grid w-full gap-3 py-7 text-left sm:grid-cols-12 sm:items-center sm:gap-6" data-id="element-7668" data-mp="2cvmv7a7lyv3q">
                <span className="flex items-center gap-4 sm:col-span-5" data-id="element-7669" data-mp="3afzfn80gszd2">
                  <span aria-hidden="true" className={iconCircleOnClay} data-id="element-7670" data-mp="2vsebrbvrmw43">
                    <PlayIcon className="h-3 w-3 fill-current" strokeWidth={1.5} data-id="element-7671" data-mp="2vqac564wgj9m" />
                  </span>
                  <span data-id="element-7672" data-mp="30ov4ykhto0o1">
                    <span className="sr-only" data-id="element-7673" data-mp="3oga7ad9lmhza">Beluister </span>
                    <span className="block type-title" data-id="element-7674" data-mp="3oez4ogrw3g9r">{e.title}</span>
                    <span className="mt-0.5 block text-[13px] text-shell" data-id="element-7675" data-mp="3t93dl5kptydh">
                      Afl. {e.number} · {e.duration}
                    </span>
                  </span>
                </span>
                <span className="text-[15px] leading-relaxed text-shell sm:col-span-7" data-id="element-7676" data-mp="1csx8s6pt2wfi">{e.summary}</span>
                <span className="sr-only" data-id="element-7677" data-mp="1rhjo48ffno6q">{shopLabels.newTab}</span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}